<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="6">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$t('labels.due_at')" :sortable="resourceState.sort" :col="'due_at'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.title')" :sortable="resourceState.sort" :col="'title'" @click="applySort"></bs-th>
            <th scope="col">{{ $tc('labels.customer', 1) }}</th>
            <th scope="col">{{ $tc('labels.field_worker', 0) }}</th>
            <th scope="col" style="width:50%">{{ $t('labels.description') }}</th>
            <th scope="col"></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td style="min-width:165px">
            <span v-if="r.due_at">{{ r.due_at | luxon }}</span>
          </td>
          <td>
            <strong>{{ r.title }}</strong><br>
            <small>{{ $t('labels.managed_by', { name: find(users, 'id', r.manager_id, 'name') }) }}</small>
          </td>
          <td>
            {{ find(customers, 'id', r.customer_id, 'name') }}<br>
            <small v-if="r.property">{{ r.property.label }}</small>
          </td>
          <td>
            <div v-for="user in r.users" :key="'ua' + r.id + user.id" class="mb-1">
              <avatar :user="user" showName />
            </div>
          </td>
          <td v-html="nl2br(r.description)"></td>
          <td class="t2">
            <bs-actions>
              <template v-slot:primary>
                <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
              </template>
              <template v-slot:secondary>
                <button class="dropdown-item" @click="convert(r)">{{ $t('labels.action_resource', { action: $t('labels.convert'), resource: $t('labels.booking') }) }}</button>
                <button class="dropdown-item" @click="convertToProject(r)">{{ $t('labels.action_resource', { action: $t('labels.convert'), resource: $tc('labels.project', 1) }) }}</button>
                <button class="dropdown-item" @click="destroy(r)">{{ labels.delete }}</button>
              </template>
            </bs-actions>
          </td>
        </tr>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="{ error }">
          <tuxedo-input :name="'title'" :label="$t('labels.title')" v-model="resource.title" :error="error" />
          <tuxedo-select :name="'manager_id'" :label="$tc('labels.manager', 1)" v-model="resource.manager_id" :options="users" :insistLabel="'name'" :insistReturn="'id'" :error="error" />
          <tuxedo-select :name="'customer_id'" :label="$tc('labels.customer', 1)" v-model="resource.customer_id" :options="customers" :insistLabel="'name'" :insistReturn="'id'" :error="error" />
          <tuxedo-select :name="'property_id'" :label="$tc('labels.property', 1)" v-model="resource.property_id" :options="properties" :insistReturn="'id'" :error="error" />
          <tuxedo-select :name="'users'" :label="$tc('labels.field_worker', 0)" v-model="resource.users" :options="users" :insistLabel="'name'" :multi="true" :error="error" />
          <text-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="error" />
          <tuxedo-date :insistFormat="'isoDate'" :name="'due_at'" :label="$t('labels.due_at')" v-model="resource.due_at" :error="error" />
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'convert-' + $options.name" :label="$t('labels.action_booking', { action: resource.id ? $t('labels.edit') : $t('labels.create') })" class="allow-overflow">
      <booking-modal :resource="resource" @submit="confirmConversion" />
    </bs-modal>
    <bs-modal :name="'convert-to-project-' + $options.name" :label="$t('labels.action_resource', { action: $t('labels.convert'), resource: $tc('labels.project', 1) })" class="allow-overflow">
      <bs-form :submit="$t('labels.submit')" @submit="confirmConversionToProject">
        {{ $t('messages.convert_to_project') }}
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
    <portal to="app-footer">
      <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'ListItems',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'clipboard-list'],
      resource: {
        title: '',
        manager_id: null,
        customer_id: null,
        property_id: null,
        users: [],
        description: null,
        due_at: null
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.listItems,
      resourceState: state => state.listItemsState,
      users: state => state.usersStore,
      customers: state => state.customersStore,
      properties: state => state.propertiesStore
    })
  },
  watch: {
    'resource.customer_id': function (val) {
      this.$store.dispatch('index', {
        collection: 'Properties',
        path: 'customers',
        id: val,
        tag: 'properties'
      })
    }
  },
  methods: {
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.resource.manager_id = this.auth.id
      this.$modal.show('create-' + this.$options.name)
    },
    convert (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.resource.type = 'listItem'
      this.$modal.show('convert-' + this.$options.name)
    },
    convertToProject (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.resource.type = 'listItem'
      this.$modal.show('convert-to-project-' + this.$options.name)
    },
    confirmConversion () {
      this.$store.dispatch('store', { collection: 'Bookings', resource: this.resource }).then(() => {
        this.$store.commit('processResponse', { collection: 'listItems', data: { id: this.resource.id } })
        this.$modal.hide('convert-' + this.$options.name)
      })
    },
    confirmConversionToProject () {
      this.$store.dispatch('store', { collection: 'Projects', resource: this.resource }).then(() => {
        this.$store.commit('processResponse', { collection: 'listItems', data: { id: this.resource.id } })
        this.$modal.hide('convert-to-project-' + this.$options.name)
      })
    }
  }
}
</script>
